import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

function importTradeGeneralOnboardingModal() {
    return import(
        /* webpackChunkName: "TradeGeneralOnboardingModalChunk" */
        './TradeGeneralOnboardingModalRenderer'
    ).then(moduleExport => moduleExport.TradeGeneralOnboardingModalRenderer);
}

export const launchTradeGeneralOnboarding = ({ customActionType }) => dispatch => {
    importModuleAndRenderNotification({
        importFunc: importTradeGeneralOnboardingModal,
        containerClassName: 'tradeGeneralOnboardingContainer',
    });

    return dispatch({ type: customActionType.actionType });
};
